import { SET_SELECTED_ACCORDION } from "../action.js";

export const setSelectedAccordion = (selectedAccordion) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_ACCORDION, payload: selectedAccordion });
  };
};
